import { UntypedFormArray, ValidatorFn } from '@angular/forms';

export function arrayNoMatchValidator(prop?: string): ValidatorFn {
	return (arr: UntypedFormArray) => {
		const valMap = prop ? arr.value.map(val => val[prop]) : arr.value.map(val => val);
		return valMap.some(x => valMap.indexOf(x) !== valMap.lastIndexOf(x)) ? { arrayNoMatch: true } : null;
	};
}
